import AddNewDocument from './AddNewDocument'

export default AddNewDocument
